import { render, staticRenderFns } from "./ConfirmLocation.vue?vue&type=template&id=c36dbb46&scoped=true"
import script from "./ConfirmLocation.vue?vue&type=script&lang=js"
export * from "./ConfirmLocation.vue?vue&type=script&lang=js"
import style0 from "./ConfirmLocation.vue?vue&type=style&index=0&id=c36dbb46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c36dbb46",
  null
  
)

export default component.exports